<template>
    <div>
        <div class="grid-container">
            <div class="grid-x" v-if="studies">
                <div class="cell">
                    <br />
                    <p class="text-right">
                        <router-link to="SuggestStudy" class="button">{{labels.suggestNewStudy}}</router-link>
                    </p>
                </div>
                <div class="table__wrapper cell">
                    <table class="table table table--saved-studies-member">
                        <caption>{{labels.mySuggestedStudies}}</caption>
                        <thead>
                            <tr>
                                <th>{{labels.date}}</th>
                                <th>{{labels.state}}</th>
                                <th>{{labels.titleOfStudy}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="studies.length > 0">
                            <tr v-for="(study, k) of studies" :key="k" :title="study.studyTitle">
                                <td>{{study.updatedDate | formatDate}}</td>
                                <td>{{study.status}}</td>
                                <td>
                                    <a tabindex="0" @click="openStudy(study.studyId)" @keyup.enter="openStudy(study.studyId)" class="button small" v-if="study.published">{{labels.goToStudy}}</a>
                                    <span>{{trimmedTitle(study.studyTitle)}}</span>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr> 
                                <td colspan="4" class="table__nothing">{{labels.youHaveNoSuggestedStudies}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="grid-x" v-else>
                <div class="cell">
                    <div class="loader__wrapper loader__wrapper--loading loader__wrapper--md">
                        <div class="loader">
                            <div class="loader__circle"></div>
                            <div class="loader__text">{{labels.loadingStudies}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "myStudiesMember",
  data() {
      return {
      }
  },
  methods: {
    trimmedTitle(title) {
      if (title.length > 100) {
        title = title.slice(0, 90) + "...";
      }
      return title;
    },
    openStudy(id) {
        window.location.href = window.vm.paths.studySummary + id;
    }
  },
  computed: {
      studies() {
        return this.$store.state.myStudiesMember;
    },
    labels() {
        return this.$store.state.labels['pages.mypage.mystudies'] || { };
    }
  },
    mounted() {
        this.$store.dispatch('getLabels', { label: 'pages.mypage.mystudies' });
        this.$store.dispatch('getMyStudiesMember');
    },
    updated() {
        // The view has been re-rendered
        this.isViewUpdated = true;
    },
};
</script>



// WEBPACK FOOTER //
// src/components/my-pages/MyStudiesMember.vue